module.exports = __webpack_public_path__ + "media/components/icons/SVG/map-8ca363d55cd6de5becde80fb3608bb4c.svg";